(() => {
 if (customElements.get('dunya-accent-bg-slider')) return;
 class BackgroundSlider extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController(); const signal = this.controller.signal;
   const size = () => this.style.setProperty('--dab-viewport', document.documentElement.clientWidth + 'px');
   size(); window.addEventListener('resize',size,{signal});
   this.slides = [...this.querySelectorAll('[data-slide]')];
   this.dots = [...this.querySelectorAll('[data-dot]')]; this.index = 0;
   if (this.slides.length < 2) return;
   this.querySelector('.dab__controls').hidden = false;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.editor = Boolean(window.Shopify?.designMode);
   this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.editor;
   this.pauseButton = this.querySelector('[data-pause]');
   this.pauseButton.hidden = this.dataset.autoplay !== 'true' || this.editor;
   this.show = (n, announce = false) => {
    this.index = (n + this.slides.length) % this.slides.length;
    this.slides.forEach((slide,i) => slide.classList.toggle('is-active', i===this.index));
    this.dots.forEach((dot,i) => dot.setAttribute('aria-pressed',String(i===this.index)));
    if (announce) this.querySelector('[data-status]').textContent = `Background image ${this.index+1} of ${this.slides.length}`;
   };
   const stopForUser = () => { this.paused=true; this.schedule(); };
   this.querySelector('[data-prev]').addEventListener('click',()=>{stopForUser();this.show(this.index-1,true);},{signal});
   this.querySelector('[data-next]').addEventListener('click',()=>{stopForUser();this.show(this.index+1,true);},{signal});
   this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{stopForUser();this.show(i,true);},{signal}));
   this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},{signal});
   this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule();},{signal});
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
   this.addEventListener('focusin',stopForUser,{signal});
   document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.schedule();},{signal});
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail?.blockId);if(i>=0){stopForUser();this.show(i);}},{signal});
   this.schedule();
  }
  schedule() {
   clearInterval(this.timer); this.timer=null;
   this.pauseButton.textContent=this.paused?'Play slideshow':'Pause slideshow';
   if(this.paused || this.hovered || document.hidden || this.editor) return;
   this.timer=setInterval(()=>this.show(this.index+1),Math.max(3,Number(this.dataset.interval)||6)*1000);
  }
  disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.controller=null;this.hovered=false;}
 }
 customElements.define('dunya-accent-bg-slider',BackgroundSlider);
})();
